<template>
  <main class="flex">
    <PageSidebar />
    <PageMain />
  </main>
</template>

<script>
import PageMain from './components/PageMain.vue';
import PageSidebar from './components/PageSidebar.vue';

export default {
  name: 'App',
  components: {
    PageSidebar,
    PageMain
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
</style>
